import { useEffect, useRef } from 'react';

export const useAfterFirstRender = (func, deps) => {
  const didRender = useRef(false);

  useEffect(() => {
    if (didRender.current) func();
    else didRender.current = true;
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};

